/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    ol: "ol",
    li: "li",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: _jsx(_components.code, {
        children: "css"
      })
    }), "\n", _jsx(_components.p, {
      children: "A helper function to generate CSS from a template literal with interpolations. You need to use this if you return a\ntemplate literal with functions inside an interpolation due to how tagged template literals work in JavaScript."
    }), "\n", _jsx(_components.p, {
      children: "If you're interpolating a string you do not need to use this, only if you're interpolating a function."
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsx(Code, {
                children: "TaggedTemplateLiteral"
              }), "\n"]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: "A tagged template literal with your CSS and interpolations."
        })]
      })
    }), "\n", _jsx(_components.p, {
      children: "Returns an array of interpolations, which is a flattened data structure that you can pass as an interpolation\nitself."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled, { css } from 'styled-components'\n\ninterface ComponentProps {\n  $complex?: boolean;\n  $whiteColor?: boolean;\n}\n\nconst complexMixin = css<ComponentProps>`\n  color: ${props => (props.$whiteColor ? 'white' : 'black')};\n`\n\nconst StyledComp = styled.div<ComponentProps>`\n  /* This is an example of a nested interpolation */\n  ${props => (props.$complex ? complexMixin : 'color: blue;')};\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["If you leave off the css your function will be ", _jsx(_components.code, {
        children: "toString()"
      }), "ed and you'll not get the results\nyou expected."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
